import { createEffect, createEvent, createStore } from "effector";
import { PlayerProfile } from "../../../types/alice-bob";

export const TUTORIAL_TOKEN = "alice_bob_tutorial"

export const coldStart = (): number => {
    const localToken = localStorage.getItem(TUTORIAL_TOKEN);
    if (localToken && localToken != 'null') {
        if (localToken == 'completed') return -2;
        const localTokenParsed = parseFloat(localToken);
        if (Number.isNaN(localTokenParsed)) throw new Error('Local storage tutorial parsing error: ' + localToken);
        return localTokenParsed
    }
    return -1
}

export const $tutorialStep = createStore<number>(coldStart());
export const setTutorialStep = createEvent<number>();
export const resetTutorialStep = createEvent();

$tutorialStep.on(resetTutorialStep, (_, __) => {
    console.log('Reset to -1')
    return -1;
})

$tutorialStep.on(setTutorialStep, (currentStep, incomingStep) => {
    if (currentStep == -2) return currentStep; // Tutorial finished
    else if (currentStep == -1) { // Tutorial just started
        if (incomingStep == -1) return currentStep;
        return incomingStep
    } else if (currentStep == 0) return currentStep; // Have no flow for skipping tutorial yet
    else if (currentStep > 0) {
        if (incomingStep <= currentStep && incomingStep != -2) return currentStep;
        return incomingStep
    }

    if (currentStep != incomingStep) return incomingStep;
})

$tutorialStep.watch(newStep => {
    window.devtodev.tutorial(newStep)
    localStorage.setItem(TUTORIAL_TOKEN, newStep + '');
    console.log('Set step tutorial to: ', newStep)
})